import script from "./PublicBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicBar.vue?vue&type=script&setup=true&lang=js"

import "./PublicBar.vue?vue&type=style&index=0&id=66c85de4&lang=less&scoped=true"

import exportComponent from "E:\\self\\loyi\\pro-DT-member-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c85de4"]])

export default __exports__